// extracted by css-extract-rspack-plugin
export default {"year":"year--RPqRvm6IH4CxwuVo"};